import { getRequest, postRequest, deleteRequest } from './util/requestAlias';
import { buildURL, buildRequestBody } from './util/requestHandler';
/**
 * 🔐删除举报
 *
 * 删除举报。
 */
export const del = params => deleteRequest(buildURL('/reports/{reportable_type}:{reportable_id}', params));
/**
 * 🔑添加举报
 *
 * 添加举报。
 */
export const create = params => postRequest(buildURL('/reports/{reportable_type}:{reportable_id}', params, ['include']), buildRequestBody(params, ['reason']));
/**
 * 🔐批量删除举报
 *
 * 批量删除举报。  只要没有错误异常，无论是否有记录被删除，该接口都会返回成功。
 */
export const deleteMultiple = params => deleteRequest(buildURL('/reports/{report_targets}', params));
/**
 * 🔐获取被举报的内容列表
 *
 * 获取被举报的内容列表。
 */
export const getList = (params = {}) => getRequest(buildURL('/reports', params, ['page', 'per_page', 'include', 'reportable_type']));
/**
 * 🔐获取被举报内容的举报详情
 *
 * 获取被举报内容的举报详情。
 */
export const getReasons = params => getRequest(buildURL('/reports/{reportable_type}:{reportable_id}', params, ['page', 'per_page', 'include']));